import { CSSProperties } from "react";

export function ArrowDown({ height, style }: { height: number, style?: CSSProperties }) {
    return <svg style={style} width="20" height={height} viewBox={`0 0 20 ${height}`}>
        <line x1="10" y1="0" x2="10" y2={height} strokeWidth={2} stroke="currentColor" />
        <line x1="3" y1={height - 10} x2="10" y2={height} strokeWidth={2} stroke="currentColor" />
        <line x1="17" y1={height - 10} x2="10" y2={height} strokeWidth={2} stroke="currentColor" />
    </svg>;
}
